module.exports = __webpack_public_path__ + "img/logo.f7337fbe.png";